import { supabase } from "../supabase";

export interface Comment {
  id: string;
  media_id: string;
  author_id: string;
  body: string;
  created_at: string;
}

/** コメントの最大文字数。つぶやきと同じ短さで、会話のテンポを保つ */
export const COMMENT_MAX = 140;

/** 前後の空白を落とし、空・長すぎは無効とみなす */
export function normalizeComment(raw: string): string | null {
  const body = raw.trim();
  return body === "" || body.length > COMMENT_MAX ? null : body;
}

/** 1件に付いたコメント。古い順(会話として読む) */
export async function fetchComments(mediaId: string): Promise<Comment[]> {
  const { data, error } = await supabase
    .from("media_comments")
    .select("id, media_id, author_id, body, created_at")
    .eq("media_id", mediaId)
    .order("created_at", { ascending: true });
  if (error) throw error;
  const rows: Comment[] = data;
  return rows;
}

/** メディアごとのコメント件数。行を引いて手元で数える(二人の規模なら十分) */
export async function fetchCommentCounts(): Promise<Map<string, number>> {
  const { data, error } = await supabase.from("media_comments").select("media_id");
  if (error) throw error;
  const rows: { media_id: string }[] = data;
  const counts = new Map<string, number>();
  for (const row of rows) counts.set(row.media_id, (counts.get(row.media_id) ?? 0) + 1);
  return counts;
}

/** author_id は DB 側の既定値で auth.uid() が入る */
export async function addComment(mediaId: string, body: string): Promise<void> {
  const { error } = await supabase.from("media_comments").insert({ media_id: mediaId, body });
  if (error) throw error;
}
